import { ICurrentUser } from '@jetslash/market-frontend-shared-core/src/types/models/user';

interface ISignUpStepPropGroup {
  firstName?: string;
  lastName?: string;
  email?: string;
  username?: string;
  phone?: string;
  signUpStep: number;
}

export class SignUpStepPropGroup {
  static create = (user: ICurrentUser, signUpStep: 1 | 2 | 3 | 4): ISignUpStepPropGroup => ({
    firstName: user?.firstName,
    lastName: user?.lastName,
    email: user?.email,
    username: user?.email,
    phone: user?.unconfirmedPhone,
    signUpStep,
  });

  static signUpSteps: { [key: string]: 1 | 2 | 3 | 4 } = {
    INITIAL_FORM: 1,
    EMAIL_VERIFICATION: 2,
    SMS_ENTRY: 3,
    SMS_CONFIRMATION_ENTRY: 4,
  };
}

export default SignUpStepPropGroup;
